/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react'
import { cloneDeep } from 'lodash';
import { useAppDispatch, useAppSelector } from '../../../../rmsReduxStore/rmsReduxHooks';
import { chargerTypes } from '../../../../rmsReduxStore/reduxExports';
import { updateMasterInfo, useEffectOnce } from '../../../../globalUtils/globalHooks';
import ParametersTable from '../../../../globalUtils/ParametersTable/ParametersTable';
import { ChargerParameterRef } from '../../../../components/chargers/ChargerPanel/ChargerPanelStatus/ChargerPanelStatusSecondOption';
import { useLocation } from 'react-router-dom';
import { getAcChargerReducer } from '../../../rmsReduxStore/acReduxExports';
import { fetchAcChargerStatusMasterInfo, fetchAcChargerStatusSystemInfo } from '../../../rmsReduxStore/acChargersRedux/acChargerCreators';

interface ChargerPanelStatus {
  contentHeight: number,
}

const AcChargerStatusParameters = forwardRef<ChargerParameterRef,ChargerPanelStatus>(({contentHeight},ref ) => {

  const [systemInfoData, setSystemInfoData] = useState<ChargerMasterInfo[] | null>(null);
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { chargerStatusMasterInfo, chargerStatusSystemInfo } = useAppSelector(getAcChargerReducer);

  useEffect(() => {
    if (chargerStatusMasterInfo !== null && chargerStatusSystemInfo !== null) {
      const chargerMasterData = cloneDeep(chargerStatusMasterInfo);
      const chargerSystemData = cloneDeep(chargerStatusSystemInfo);
      const data = updateMasterInfo(chargerMasterData, chargerSystemData);
      // : Partial<ChargerAction>
      const action = {
        type: chargerTypes.SET_ALTERED_MASTER_DATA_FOR_CHARGER_STATUS,
        chargerStatusMasterInfoAltered: data,
      }
      dispatch(action);    
      setSystemInfoData(data)
    }
  }, [chargerStatusMasterInfo, chargerStatusSystemInfo])


  useEffectOnce(() => {
    dispatch(fetchAcChargerStatusMasterInfo({ chargerId: location?.state?.chargerId }, true));
    dispatch(fetchAcChargerStatusSystemInfo({ chargerId: location?.state?.chargerId }));
  })
  
  return (
    <div ref={ref} className='charger__status__parameters__table' style={{ height: `${contentHeight}px` }}>
      <ParametersTable data={systemInfoData} containerClassName={'charger__status__parameters'} />
    </div>

  )
})

export default AcChargerStatusParameters